module.exports = __webpack_public_path__ + "3945475605e81906c18d1bf993d1755c.svg";